'use client'
const waitForConnection = (provider) => new Promise((resolve) => {
    provider.once('connect', () => resolve());
});

export { waitForConnection };
